document.addEventListener('DOMContentLoaded', function() {
    new Vue({
        el: '#popup-product-wrap',
        data: {
            isOpen: false,
            skuProduct: '',
            loaderStatus: false,
            showFullPricesOnly: false,
            product : false,
            zoomImagePath : '',
            openZoomImageModal : false,
            imgParamD : [{'w' : 475}, {'h' : 475}, {'fit' : 'fill'}, {'fill' : 'solid'}, {'fill-color' : 'ffffff'}],
            imgParamM : [{'w' : 790}, {'h' : 790}, {'fit' : 'fill'}, {'fill' : 'solid'}, {'fill-color' : 'ffffff'}],
        },
        created: function () {
            eventBus.$on('show-popup-product-event', this.showPopupProduct);
        },
        methods: {
            showPopupProduct : function (_productId, _showFullPricesOnly) {
                MAIN.disableScroll();
                this.isOpen = true;
                this.skuProduct = _productId;
                this.fetchData(l10n.baseSearchUrl, {"filter" : "sku = " + this.skuProduct} );
                this.showFullPricesOnly = _showFullPricesOnly === 'showFullPricesOnly' ? true : false;
                setTimeout(function(){
                    MAIN.initSlider();
                }, 250)
            },
            fetchData: function (_jsonServiceUrl,params) {
                var self = this;
                self.loaderStatus = true;
                var xhr = new XMLHttpRequest();
                xhr.open('POST', _jsonServiceUrl);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.setRequestHeader("Authorization", "Bearer " + l10n.searchKey);
                xhr.onload = function () {
                    try {
                        var products = JSON.parse(xhr.responseText);
                        if( typeof products.hits[0] !== "undefined"){
                            self.product = products.hits[0];
                            self.defineRenderElement();
                            self.loaderStatus = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                };
                xhr.send( JSON.stringify(params) );
            },
            closePopup : function(){
                this.isOpen = false;
                MAIN.enableScroll();
            },
            openModalZoomImage : function(_path){
                console.log("openModalZoomImage", _path);
                if(document.body.classList.contains('touch')){
                    window.open(_path, '_blank');
                } else {
                    this.zoomImagePath = _path;
                    this.openZoomImageModal = true;
                }
            },
            closeModalZoomImage : function(){
                this.openZoomImageModal = false;
            },
            defineRenderElement : function(){
                globalFunctions.getRenderPrices(this.product, this.showFullPricesOnly);
            },
            getImageByParam : function(url, param){
                if(typeof url === 'string' && url && url !== ' ' && typeof param === 'object'){
                    var urlParam = new URL(url);
                    for (var i = 0; i < param.length; i++){
                        var keyP = Object.keys(param[i]);
                        urlParam.searchParams.append( keyP, param[i][keyP] );
                    }
                    return urlParam.href;
                }
                return 'url-image-error';
            },
            renderStarWidth : function(_val){
                return _val * 100 / 5 + '%';
            },
            getRenderIngredients : function(){
                var returnIngredients = '';
                returnIngredients += this.product.mainIngredients;
                if(this.product.mainIngredients && this.product.fullIngredients){
                    returnIngredients += '<br /><br /><hr><br />';
                }
                returnIngredients += this.product.fullIngredients;

                return returnIngredients
            }
        },
    })
});